<button class="button p-l-4-x p-l-4-l p-r-4-x p-r-4-l"
        [class.is-disabled]="disabled || !isSalable"
        [action]="status"
        (click)="buyGiftcard()">
    <span>
        @if (isSalable || disabled) {
        {{'Add to bag' | translate}}
        }
        @if (!isSalable && !disabled) {
        {{'Out of stock' | translate}}
        }
    </span>
</button>
<result class="block"
        [status]="status" />